import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

// import { actions } from '../features/member-profile-slice';
import { readProfile } from '../features/member-profile-thunk';

import { ZetaSection, ZetaGroup } from '../zeta-widget';
// import { useZetaDispatchChange } from '../zeta-widget/tools/handle-tool'
import { updatePassword } from '../controllers/member';
import { showAlert } from '../zeta-widget/tools/alert-tool'

const tplPassword = require('../templates/member-password.json');

export function MemberPasswordPage(props) {
  const profile = useSelector((state) => state.memberProfile.data);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(readProfile());
  },[dispatch]);

  const handleActionClick = useCallback((e) => {
    switch(e.target.name) {
      case 'btnBack':
        history.goBack();
        return;

      case 'btnSave':
        const formdata = new FormData(document.getElementById('pwdform'));
        const data = Object.fromEntries(formdata);
        updatePassword(data, (err, result) => {
          if (err) {
            showAlert(err, 'danger');
            return;
          }

          showAlert(result.message);
          history.push('/member/home');
        });
        return;
  
      default:
        break;
    }      
  }, [history]);

  const handlers = {
    handleActionClick
  };

  const _this = {
    // activeSection,
    handlers,
  };

  return (
    <>
      <ZetaSection name="entry" title="แก้ไขรหัสผ่าน" app={_this}>
        <form id="pwdform">
          <ZetaGroup size="medium" template={tplPassword} 
            data={profile} 
            app={_this}
            // onChange={handleChange} 
          />
        </form>
      </ZetaSection>
    </>
  );

}